// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateComment-cls1___66668c48be1176440ff{/*!*/}.CreateComment-cls2___bd0fd1be434aa4dbd3c{margin-top:16px;border-radius:8px;border-radius:var(--corner-radius-radius-md, 8px);overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateComment-cls1___66668c48be1176440ff",
	"cls2": "CreateComment-cls2___bd0fd1be434aa4dbd3c CreateComment-cls1___66668c48be1176440ff"
};
export default ___CSS_LOADER_EXPORT___;
